module.exports = __webpack_public_path__ + "img/symbol_15.c6dcd901.png";